import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LineChartComponent } from './line-chart/line-chart.component';
import { DoughnutChartComponent } from './doughnut-chart/doughnut-chart.component';
import { HorizontalBarChartComponent } from './horizontal-bar-chart/horizontal-bar-chart.component';
import { TableChartComponent } from './table-chart/table-chart.component';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { FlexLayoutModule } from '@angular/flex-layout';
import { PieChartComponent } from './pie-chart/pie-chart.component';
import { MatIconModule } from '@angular/material/icon';


@NgModule({
	declarations: [
		LineChartComponent,
		DoughnutChartComponent,
		HorizontalBarChartComponent,
		TableChartComponent,
		PieChartComponent],
	imports: [
		CommonModule,
		MatProgressBarModule,
		MatIconModule,
		FlexLayoutModule
	],
	exports: [
		LineChartComponent,
		DoughnutChartComponent,
		HorizontalBarChartComponent,
		TableChartComponent,
		PieChartComponent
	]
})
export class ChartsModule { }
